<template>
    <LcForm :formData="formData"
        :formSettings="formSettings"
        :productName="props.productName"
        @completed.once="componentSettings.isCompleted = true"
    />
</template>

<script setup>

import { reactive, onMounted } from 'vue';

import LcForm from '@/components/form/LcForm.vue';
import { resolveIframeSteps } from '@/form/products/iframe-steps.js';
import { useComponentProps } from '@/composables/useComponentProps.js';
import { useInjectedApplicationSettings } from '@/composables/useApplicationSettingsProvider.js';
import { DEFAULT_FORM_SETTINGS } from '@/constants/form-settings.js';

const props = defineProps({
    productName: {
        type: String,
        default: 'personal_loan',
    },
    version: {
        type: String,
        default: 'v1',
    },
    componentSettings: {
        type: Object,
        required: true,
    },
    country: {
        type: String,
        default: 'CA',
    },
    // Optional step groups this iframe renders, resolved server-side.
    features: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['update:componentSettings']);

const { componentSettings } = useComponentProps(props, emit, ['componentSettings']);

const applicationSettings = useInjectedApplicationSettings();
const formSettings = DEFAULT_FORM_SETTINGS;

// Derived from the site product's own step set, then feature-filtered. Read
// once at setup: product, country and features are fixed for a page render.
const formData = reactive({
    steps: resolveIframeSteps({
        product: props.productName,
        country: props.country,
        version: props.version,
        features: props.features,
    }),
    onSubmit: true,
});

onMounted(() => {
    applicationSettings.loadingAnimationSeconds = 0;
});

</script>
